module.exports = __webpack_public_path__ + "img/goldregen-2020-091.355b1efb.jpg";